export const COPY = {
  somethingWentWrong: {
    title: 'Something went wrong',
    message:
      'The form could not be submitted. If the problem persists, please contact us for support.'
  }
}
